<template>
  <a-dropdown :trigger="['click']" placement="bottomRight">
    <button type="button" class="column-chooser-btn" title="Choose columns">
      <i class="fa fa-columns"></i>
      <span>Columns</span>
    </button>
    <template #overlay>
      <div class="column-chooser-panel" @click.stop>
        <div class="cc-head">Show columns</div>
        <label
          v-for="c in columns"
          :key="c.key"
          class="cc-row"
          :class="{ disabled: c.required }"
        >
          <input
            type="checkbox"
            :checked="isOn(c.key)"
            :disabled="c.required"
            @change="toggle(c.key)"
          />
          <span>{{ c.label }}</span>
        </label>
        <button type="button" class="cc-reset" @click="$emit('reset')">
          Reset to default
        </button>
      </div>
    </template>
  </a-dropdown>
</template>

<script>
/**
 * Column visibility picker. `columns` is [{ key, label, required? }];
 * `modelValue` is the list of visible keys. Required columns can't be toggled off.
 */
export default {
  name: "ColumnChooser",
  props: {
    columns: { type: Array, default: () => [] },
    modelValue: { type: Array, default: () => [] },
  },
  emits: ["update:modelValue", "reset"],
  methods: {
    isOn(key) {
      return this.modelValue.includes(key);
    },
    toggle(key) {
      const set = new Set(this.modelValue);
      if (set.has(key)) set.delete(key);
      else set.add(key);
      this.$emit("update:modelValue", Array.from(set));
    },
  },
};
</script>

<style lang="scss" scoped>
.column-chooser-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.4rem;
  height: 36px;
  padding: 0 0.75rem;
  border: 1px solid #e2e5ea;
  background: #fff;
  color: #475569;
  border-radius: 8px;
  font-size: 0.82rem;
  font-weight: 500;
  cursor: pointer;
  white-space: nowrap;
  &:hover {
    border-color: #cbd2dc;
    color: #334155;
  }
}
.column-chooser-panel {
  background: #fff;
  border-radius: 8px;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.12);
  padding: 0.5rem;
  min-width: 200px;
  max-height: 360px;
  overflow-y: auto;
  .cc-head {
    font-size: 0.7rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    color: #94a3b8;
    padding: 0.35rem 0.5rem;
  }
  .cc-row {
    display: flex;
    align-items: center;
    gap: 0.5rem;
    padding: 0.4rem 0.5rem;
    border-radius: 6px;
    font-size: 0.85rem;
    color: #334155;
    cursor: pointer;
    &:hover {
      background: #f6f7f9;
    }
    &.disabled {
      color: #94a3b8;
      cursor: default;
    }
    input {
      cursor: inherit;
    }
  }
  .cc-reset {
    width: 100%;
    margin-top: 0.35rem;
    padding: 0.45rem;
    border: none;
    border-top: 1px solid #eef0f3;
    background: transparent;
    color: #584dee;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    border-radius: 0 0 6px 6px;
    &:hover {
      background: #f6f7f9;
    }
  }
}
</style>
